import './global.css';

import type { ProjectConfigInput } from '#core/schema/ProjectConfigSchema.ts';

import { theme } from './theme.ts';
import faviconUrl from '#assets/adnoc-favicon.svg';
import { AdnocLogo } from '#components/AdnocLogo.tsx';

export const config = {
  id: 'cognite-dashboard-aipso',
  name: 'Cognite AiPSO Dashboard',
  logo: AdnocLogo,
  faviconUrl,
  defaultColorScheme: 'dark',
  debug: { devtools: { enabled: false } },
  theme,
  feature: {
    ai: {
      enabled: true,
      agent: {
        name: 'AiPSO AI Advisor',
      },
    },
  },
} as const satisfies ProjectConfigInput;
